export var paginateRange = function paginateRange(start, end) {
  if (start < 1 || Number.isNaN(Number.parseFloat(start)) || Number.isNaN(Number.parseFloat(end))) {
    return [];
  }
  var length = end - start + 1;
  return Array.from({
    length: length
  }, function (item, idx) {
    return idx + start;
  });
};